import * as React from 'react';
export const duplicateSvg = React.forwardRef(function duplicateSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13 0a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-1.5v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5.25c0-.966.784-1.75 1.75-1.75a.75.75 0 0 1 0 1.5.25.25 0 0 0-.25.25V14a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5v-1H6.5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2H13ZM6.5 1.5A.5.5 0 0 0 6 2v9a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H6.5Z',
    }),
  );
});
duplicateSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var duplicate = {
  category: 'icon',
  colorable: true,
  name: 'duplicate',
  svg: duplicateSvg,
};
